// @ts-nocheck
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// material
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { Box, Drawer, Typography, Theme, useTheme, Button } from '@mui/material';
// components
import Logo from '../components/Logo';
import GsgroupLogo from '../components/GsgroupLogo';
import Scrollbar from '../components/Scrollbar';
import NavSection from '../components/NavSection';
import MHidden from '../components/@material-extend/MHidden';
//
import SidebarConfig from './SidebarConfig';
import { AppState } from '../Common/Reducer/rootReducerTypes';
import Cookies from 'universal-cookie';
import useLocales from '../hooks/useLocales';
import { useDisplayName } from '../hooks/useDisplayName';
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;


const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[500_12]
}));

const DocStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor:
    theme.palette.mode === 'light'
      ? alpha(theme.palette.primary.main, 0.08)
      : theme.palette.primary.light
}));

const useStyles = makeStyles((theme: Theme) => ({
  scrollbar: {
    height: '100%',
    '& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column' }
  }
}));

// ----------------------------------------------------------------------

type SidebarProps = {
  isOpenSidebar: boolean;
  onCloseSidebar: VoidFunction;
};

export default function Sidebar({ isOpenSidebar, onCloseSidebar }: SidebarProps) {
  const { pathname } = useLocation();
  const user = useSelector((state: AppState) => state.user);
  const userInfoState = useSelector((state: AppState) => state.userInfo);
  const theme = useTheme<Theme>();
  const classes = useStyles();
  const { translate, currentLang } = useLocales();
  const cookies = new Cookies();
  const portalVersion = cookies.get('portalVersion');

  let displayName = "";
  let company = "";

  if (user && user.profile) {
    displayName = useDisplayName();
    company = `${user.profile['company'] || ''}`;
  }

  const onClick = () => {
    // Unfortunatelly the i18next's country code and our support page localization does not match for Danish. dk vs da
    const langCode = currentLang.value === 'dk' ? 'da' : currentLang.value;
    const path = `https://support.gsgroup.no/hc/${langCode}/categories/5860616245649-Handyman-Connect`;
    window.open(path, '_blank');
  };

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line
  }, [pathname]);

  const renderContent = (
    <Scrollbar className={classes.scrollbar} >
      <Box style={{
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
      }}>
        <Box style={{
          alignItems: 'center',
          display: "flex",
          justifyContent: "center"
        }}>
          <Logo />
        </Box>
      </Box>

      {/* <Box style={{
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(2.5),
        marginRight: theme.spacing(2.5)
      }}>
        <AccountStyle>
          <MyAvatar />
          <Box style={{
            marginLeft: theme.spacing(2)
          }}>
            <Typography variant="subtitle2" style={{ color: theme.palette.text.primary }}>
              {displayName}
            </Typography>
            <Typography variant="body2" style={{ color: theme.palette.text.secondary }}>
              {company}
            </Typography>
          </Box>
        </AccountStyle>
      </Box> */}

      <NavSection navConfig={SidebarConfig()} />

      <Box style={{ flexGrow: 1 }} />

      <Box style={{
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
        paddingBottom: theme.spacing(3),
        marginTop: theme.spacing(10)
      }}>
        <DocStyle>
          {/* <DocIcon style={{ width: 36, height: 36, marginBottom: theme.spacing(2) }} /> */}
          <Typography variant="subtitle1" style={{ color: theme.palette.grey[800] }}>
            {translate('sidebar.' + "Greetings") + " "}{displayName}
          </Typography>
          <Typography variant="body2" style={{ marginBottom: theme.spacing(2), color: theme.palette.grey[600] }}>
            {translate('sidebar.NeedHelp')}
            <br />
            {translate('sidebar.CheckDocs')}
          </Typography>
          <Button fullWidth onClick={onClick} variant="contained" color='primary'>
            {translate('sidebar.Documentation')}
          </Button>
        </DocStyle>
      </Box>

      <Box style={{
        paddingLeft: theme.spacing(2.5),
        paddingRight: theme.spacing(2.5),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(2.5),
        position: 'absolute',
        bottom: 0,
        left: 0
      }}>
        <Box style={{ marginRight: theme.spacing(22) }}>
          <Typography color='textSecondary' style={{ fontSize: 8, opacity: 0.5 }}>powered by</Typography>
          <GsgroupLogo />
          <Typography color='textSecondary' style={{ fontSize: 8, opacity: 0.5 }}>version:{portalVersion}</Typography>
        </Box>
      </Box>
    </Scrollbar>
  );

  // eslint-disable-next-line
  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            style: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="mdDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            style: { width: DRAWER_WIDTH, backgroundColor: theme.palette.background.default }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
